module.exports = __webpack_public_path__ + "static/img/m_role.17d3afe.png";


//////////////////
// WEBPACK FOOTER
// ./static/hk/mobile_img/role3/ch/m_role.png
// module id = 8mrw
// module chunks = 7